<template>
    <div>
      <CashOnHandList v-show="listView" @newCash="onClickNewFromList" @editCash="onClickEditFromList" :scroll="corY" ref="refreshList" />
      <CashOnHandForm v-show="formView" :cash="cash" @backClicked="onBackChild" />
    </div>
</template>

<script>
import CashOnHandList from '@/components/cash-on-hand/CashOnHandList.vue'
import CashOnHandForm from '@/components/cash-on-hand/CashOnHandForm.vue'
import { mapState } from 'vuex'
// import Axios from 'axios'
// import { cohUrl, getHeader } from '../config'

export default {
  name: 'CashOnHand',
  components: {
    CashOnHandList,
    CashOnHandForm
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      typeList: state => state.cohs.typeList,
      companyList: state => state.companies.companyList
    })
  },
  mounted () {
    this.$store.dispatch('getPaymentMethodList')
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getCashOnHandTypeList')
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      saldo: 0,
      cash: {
        id: null,
        cash_no: null,
        cash_date: null,
        branch_no: null,
        company_no: null,
        status: null,
        lock: null,
        username: null,
        type_id: 'kas-kecil',
        total: '0',
        memo_no: null,
        notes: null,
        employee_no: null,
        outstanding: null,
        outstanding_date: null,
        details: [{
          id: null,
          cash_no: null,
          cash_date: null,
          branch_no: null,
          company_no: null,
          method_id: null,
          bank_id: null,
          tax_id: null,
          tax: 0,
          amount: '0',
          total: '0',
          description: '',
          memo_no: null,
          type: '',
          account_code: null,
          total_journal: '0'
        }],
        journals: [{
          id: null,
          journal_code: null,
          type_id: null,
          journal_date: null,
          ref_no: null,
          contact: null,
          journal_description: null,
          status: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          details: [{
            id: null,
            journal_code: null,
            account_code: null,
            account: null,
            remark: null,
            debit: '0',
            credit: '0',
            branch_no: null,
            company_no: null,
            journal_date: null
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          user_id: null,
          user: null,
          ref: null,
          description: null
        }]
      }
    }
  },
  methods: {
    async getSaldo (company, cashDate) {
      const cmp = this.companyList.find(d => d.company_no === company)
      var cid = '01'
      if (cmp.company_no === 'C0001') {
        cid = '01'
      } else {
        cid = '11'
      }
      var payload = {
        account: cid + '-111-001',
        date: cashDate,
        company: company
      }
      this.$store.dispatch('getAccountSaldoAwal', payload)
    },
    async onClickNewFromList () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      const cmp = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var strid = null
      if (cmp.company_no === 'C0001') {
        strid = 'kas-kecil-asp'
      } else {
        strid = 'kas-kecil-psa'
      }
      const typeID = this.typeList.find(d => d.id === strid)
      this.cash = {
        id: null,
        cash_no: null,
        cash_date: new Date().toISOString(),
        branch_no: this.authUser.branch_no,
        company_no: this.authUser.company_no,
        status: null,
        lock: false,
        username: null,
        type_id: typeID ? typeID.id : null,
        total: '0',
        memo_no: null,
        notes: null,
        employee_no: null,
        outstanding: null,
        outstanding_date: null,
        details: [{
          cash_no: null,
          cash_date: new Date().toISOString(),
          branch_no: this.authUser.branch_no,
          company_no: this.authUser.company_no,
          method_id: 1,
          bank_id: null,
          tax_id: null,
          tax: 0,
          amount: '0',
          total: '0',
          description: '',
          memo_no: null,
          type: 'outcome',
          account_code: null,
          total_journal: '0'
        }],
        journals: [{
          id: null,
          journal_code: null,
          type_id: null,
          journal_date: null,
          ref_no: null,
          contact: null,
          journal_description: null,
          status: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          details: [{
            id: null,
            journal_code: null,
            account_code: null,
            account: null,
            remark: null,
            debit: '0',
            credit: '0',
            branch_no: null,
            company_no: null,
            journal_date: null
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          user_id: null,
          user: null,
          ref: null,
          description: null
        }]
      }
      await this.getSaldo(this.cash.company_no, this.cash.cash_date)
    },
    async onClickEditFromList (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.cash = value
      this.listView = false
      this.formView = true
      console.log(this.cash.company_no, this.cash.cash_date)
      await this.getSaldo(this.cash.company_no, this.cash.cash_date)
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
      window.scrollTo(0, 0)
      this.cash = {
        id: null,
        cash_no: null,
        cash_date: null,
        branch_no: null,
        company_no: null,
        status: null,
        lock: null,
        username: null,
        type_id: 'kas-kecil',
        total: '0',
        memo_no: null,
        notes: null,
        employee_no: null,
        outstanding: null,
        outstanding_date: null,
        details: [{
          id: null,
          cash_no: null,
          cash_date: null,
          branch_no: null,
          company_no: null,
          method_id: null,
          bank_id: null,
          tax_id: null,
          tax: 0,
          amount: '0',
          total: '0',
          description: '',
          memo_no: null,
          type: '',
          account_code: null,
          total_journal: '0'
        }],
        journals: [{
          id: null,
          journal_code: null,
          type_id: null,
          journal_date: null,
          ref_no: null,
          contact: null,
          journal_description: null,
          status: null,
          debit: '0',
          credit: '0',
          branch_no: null,
          company_no: null,
          details: [{
            id: null,
            journal_code: null,
            account_code: null,
            account: null,
            remark: null,
            debit: '0',
            credit: '0',
            branch_no: null,
            company_no: null,
            journal_date: null
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          user_id: null,
          user: null,
          ref: null,
          description: null
        }]
      }
    }
  }
}
</script>
